import {
    BookOpen,
    BusFront,
    CakeSlice,
    CalendarDays,
    CircleOff,
    Clapperboard,
    Coffee,
    Dices,
    Dumbbell,
    Flower2,
    Heart,
    MicVocal,
    Mountain,
    Music2,
    Palette,
    PartyPopper,
    PawPrint,
    PersonStanding,
    Scissors,
    Sun,
    Trees,
    Trophy,
    Users,
    Utensils,
    Waves,
    Wine,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import { EventIcon } from 'src/domain/event';

const EVENT_ICON_COMPONENTS: Record<EventIcon, LucideIcon> = {
    [EventIcon.calendar]: CalendarDays,
    [EventIcon.singing]: MicVocal,
    [EventIcon.music]: Music2,
    [EventIcon.dancing]: PersonStanding,
    [EventIcon.hiking]: Mountain,
    [EventIcon.outdoors]: Sun,
    [EventIcon.park]: Trees,
    [EventIcon.gardening]: Flower2,
    [EventIcon.dinner]: Utensils,
    [EventIcon.coffee]: Coffee,
    [EventIcon.drinks]: Wine,
    [EventIcon.baking]: CakeSlice,
    [EventIcon.games]: Dices,
    [EventIcon.reading]: BookOpen,
    [EventIcon.film]: Clapperboard,
    [EventIcon.arts]: Palette,
    [EventIcon.crafts]: Scissors,
    [EventIcon.exercise]: Dumbbell,
    [EventIcon.sports]: Trophy,
    [EventIcon.swimming]: Waves,
    [EventIcon.trip]: BusFront,
    [EventIcon.celebration]: PartyPopper,
    [EventIcon.social]: Users,
    [EventIcon.wellbeing]: Heart,
    [EventIcon.animals]: PawPrint,
};

type EventIconGraphicProps = {
    icon: EventIcon;
    className?: string;
};

export const EventIconGraphic = ({
    icon,
    className,
}: EventIconGraphicProps) => {
    const Icon = EVENT_ICON_COMPONENTS[icon];

    return <Icon className={className} strokeWidth={1.8} aria-hidden="true" />;
};

export const NoEventIconGraphic = ({ className }: { className?: string }) => (
    <CircleOff className={className} strokeWidth={1.8} aria-hidden="true" />
);
